import { render, staticRenderFns } from "./device-details.vue?vue&type=template&id=33146c9c&"
import script from "./device-details.vue?vue&type=script&lang=js&"
export * from "./device-details.vue?vue&type=script&lang=js&"
import style0 from "./device-details.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports